<ng-template #tipContent>
  <div [innerHTML]="tooltipText"></div>
</ng-template>
<ng-container *ngIf="!!tooltipText">
  <i
    class="fa fa-info-circle"
    [ngbTooltip]="tipContent"
    triggers="click:blur"
    tooltipClass="my-custom-class"
  ></i>
</ng-container>
